import {
  SET_ELASTIC_ORGANIZATIONS,
  SET_COMPANY_DATA,
  SET_COMPANY_ID,
  SET_TOTAL_COMPANIES,
  SET_CONTROVERSY_LINKS,
  SET_PAGINATION_PAGE,
  SET_SURVEY_DATA,
  SET_SURVEY_PAGINATION_PAGE,
  SET_SELECTED_SURVEY,
  SET_SELECTED_SURVEY_RESPONSE,
  SET_SELECTED_RES_COMPANY,
  SET_SECTION,
  SET_QUESTIONS,
  SET_SELECTED_SECTION,
  SET_SELECTED_OPTION,
  SET_VERSION_HISTORY,
  SET_RESPONDED_ORGANIZATIONS,
  SET_PUBLISHED_SURVEY_LIST,
  SET_SUPPLIER_ACTIVE_TAB,
  SET_SURVEY_DOCUMENT,
  SET_SURVEY_TOTAL,
} from "../../constants/supplier/supplierConstant";

const initialData = [
  {
    survey_name: "survey1",
    // survey_type: surveyType,
    survey_createdBy: "Saad",
    survey_dated: "Jan 20, 2022",
    survey_status: true,
    survey_description: "default section",
  },
  {
    survey_name: "survey2",
    // survey_type: surveyType,
    survey_createdBy: "baibhav",
    survey_dated: "feb 29, 2022",
    survey_status: true,
    survey_description: "custom section",
  },
];

const initialData2 = {
  survey1: [
    { title: "Self Assessment Section" },
    { title: "Controversy Survey" },
  ],
  survey2: [
    { title: "Company Profile" },
    { title: "Information Security" },
    { title: "Data Privacy" },
    { title: "Third Party/Subcontractors" },
    { title: "Business and Ethical Conduct" },
    { title: "Environment" },
    { title: "Labour Standards" },
    { title: "Human Rights" },
    { title: "Compliance Compliance" },
    { title: "Risk Management" },
    { title: "Organizational Security" },
    { title: "Physical and Environmental Security" },
    { title: "Asset Management" },
    { title: "Asset Control" },

    { title: "Vulnerability and Threat Management" },
    { title: "Business Continuity Management" },
    { title: "Cloud Specific Requirements" },
  ],
};

const initial_state = {
  companies: [],
  currentCompanyId: "",
  totalCompanies: "",
  currentCompanyData: {},
  controversyLinks: [],
  totalLinks: 0,
  is_published: false,
  dahboardPaginationPage: 1,

  // survey data
  surveyData: [],
  selectedSurveyData: null,
  surveyPaginationPage: 1,

  // survey inner data
  selectedResponse: null,
  selectedResCompany: null,
  sectionWiseData: [],
  sectionWiseQuestion: [],
  selectedSection: "",
  respondedOrganizations: [],
  surveyRespondedUsers: [
    {
      name: "Bessie Cooper",
      _id: "2134554",
      role: "manager",
      selectedFrequency: "January",
    },
    {
      name: "Ralph Edwards",
      _id: "55514",
      role: "dev",
      selectedFrequency: "February",
    },
  ],
  selectedOption: null,
  versionHistory: [],
  publishedSurveyList: [],
  supplierActiveTab: 0,
  surveyDocument: [],

  total_survey: 0,
};

export default function supplierReducer(state = initial_state, action) {
  switch (action.type) {
    case SET_SURVEY_TOTAL:
      return (state = { ...state, total_survey: action.payload });
    case SET_ELASTIC_ORGANIZATIONS:
      return (state = { ...state, companies: action.payload });
    case SET_COMPANY_DATA:
      return (state = { ...state, currentCompanyData: action.payload });
    case SET_TOTAL_COMPANIES:
      return (state = { ...state, totalCompanies: action.payload });
    case SET_COMPANY_ID:
      return (state = { ...state, currentCompanyId: action.payload });
    case SET_PAGINATION_PAGE:
      return (state = { ...state, dahboardPaginationPage: action.payload });
    case SET_CONTROVERSY_LINKS:
      return (state = {
        ...state,
        controversyLinks: action.payload.payload,
        totalLinks: action.payload.total,
        is_published: action.payload.is_published,
      });

    // survey cases
    case SET_SURVEY_DATA:
      return {
        ...state,
        surveyData: action.payload,
      };
    case SET_SELECTED_SURVEY:
      return (state = {
        ...state,
        selectedSurveyData: action.payload,
        // sectionWiseData: initialData2[action.payload?.survey_name || "survey1"],
      });
    case SET_SURVEY_PAGINATION_PAGE:
      return (state = { ...state, surveyPaginationPage: action.payload });

    // survey inner cases
    case SET_SELECTED_SURVEY_RESPONSE:
      return (state = { ...state, selectedResponse: action.payload });
    case SET_SELECTED_RES_COMPANY:
      return (state = { ...state, selectedResCompany: action.payload });
    case SET_SECTION:
      return (state = { ...state, sectionWiseData: action.payload });
    case SET_QUESTIONS:
      return (state = { ...state, sectionWiseQuestion: action.payload });
    case SET_SELECTED_SECTION:
      return (state = { ...state, selectedSection: action.payload });
    case SET_SELECTED_OPTION:
      return (state = { ...state, selectedOption: action.payload });
    case SET_VERSION_HISTORY:
      return (state = { ...state, versionHistory: action.payload });
    case SET_RESPONDED_ORGANIZATIONS:
      return (state = { ...state, respondedOrganizations: action.payload });
    case SET_PUBLISHED_SURVEY_LIST:
      return (state = { ...state, publishedSurveyList: action.payload });
    case SET_SUPPLIER_ACTIVE_TAB:
      return (state = { ...state, supplierActiveTab: action.payload });
    case SET_SURVEY_DOCUMENT:
      return (state = { ...state, surveyDocument: action.payload });
    default:
      return state;
  }
}
